export default __webpack_public_path__ + "static/media/Elf_Framed.43cee467.png";